import {
    EndOfLifeStatusType,
    EnvironmentalRegulationType,
    EvidenceDocumentsType,
    ExportControlClassificationType,
    ServiceFieldDefinitions
} from '../NewItemInput'
import {AttributeDefinitionTypeEnum, AttributeModel} from '../../../displaySet/model/AttributeModel'
import {v4 as uuidv4} from 'uuid'
import {AttributeValue, AttributeValueType} from '../../../displaySet/model/AttributeValue'

const createAttribute = (
    value: AttributeValue,
    name: string,
    attributeDefinitionId: string,
    type: AttributeDefinitionTypeEnum
    ): AttributeModel => ({
        attributeDefinitionId,
        id: uuidv4(),
        value,
        displayOrder: 1,
        attributePosition: 1,
        name,
        unit: null,
        attributeDefinitionType: {attributeDefinitionType:type}
    })

export const toEvidenceDocumentsAttributes = (
    evidenceDocument: EvidenceDocumentsType
): AttributeModel[] => {

    const { proofs = [] } = evidenceDocument
    const attributes: AttributeModel[] = []

    proofs.forEach(proof => {
        attributes.push(createAttribute(
            {type: AttributeValueType.FILE, value: undefined, fileDocument: proof, composedByAttributes: []},
            'Upload Proof for Evidence Document',
            ServiceFieldDefinitions.EvidenceDocuments,
            AttributeDefinitionTypeEnum.FILE
        ))
    })
    return attributes
}

export const toEndOfLifeStatusAttributes = (
    endOfLifeStatus?: EndOfLifeStatusType
): AttributeModel[] => {

    if (!endOfLifeStatus) return []

    const { date, proofs = [] } = endOfLifeStatus
    const attributes: AttributeModel[] = []

    if (date) {
        attributes.push(createAttribute(
            {type: AttributeValueType.SIMPLE, value: date, composedByAttributes: [] },
            'Last buy order date',
            ServiceFieldDefinitions.EndOfLifeStatus,
            AttributeDefinitionTypeEnum.DATE
        ))
    }

    proofs.forEach(proof => {
        attributes.push(createAttribute(
            {type: AttributeValueType.FILE, value: undefined, fileDocument: proof, composedByAttributes: [] },
                'Upload Proof for End of Life Status',
                ServiceFieldDefinitions.EndOfLifeStatus,
                AttributeDefinitionTypeEnum.FILE
            ))
    })

    return attributes
    }

export const toExportControlClassificationAttributes = (
    exportControlClassificationType?: ExportControlClassificationType
): AttributeModel[] => {

    if (!exportControlClassificationType) return []

    const { type, proofs = [] } = exportControlClassificationType
    const attributes: AttributeModel[] = []

    if(type){
        attributes.push(createAttribute(
            {type: AttributeValueType.SIMPLE, value: type, composedByAttributes: []},
            'Export Control Classification Type',
            ServiceFieldDefinitions.ExportControlClassification,
            AttributeDefinitionTypeEnum.STRING
        ))
    }

    proofs.forEach(proof => {
        attributes.push(createAttribute(
            {type: AttributeValueType.FILE, value: undefined, fileDocument: proof, composedByAttributes: []},
            'Upload Proof for Export Control Classification Type',
            ServiceFieldDefinitions.ExportControlClassification,
            AttributeDefinitionTypeEnum.FILE
        ))
    })

    return attributes
}

export const toEnvironmentalRegulationAttributes = (
    environmentalRegulationTypes: EnvironmentalRegulationType[]
): AttributeModel[] => {

    const attributes : AttributeModel[] = []

    environmentalRegulationTypes.forEach(environmentalRegulationType => {

        const { type, proofs = [] } = environmentalRegulationType

        if(type){
            attributes.push(createAttribute(
                {type: AttributeValueType.SIMPLE, value: type, composedByAttributes: []},
                'Environmental Regulation Type',
                ServiceFieldDefinitions.EnvironmentalRegulation,
                AttributeDefinitionTypeEnum.STRING
            ))
        }

        proofs.forEach(proof => {
            attributes.push(createAttribute(
                {type: AttributeValueType.FILE, value: undefined, fileDocument: proof, composedByAttributes: []},
                'Upload Proof for Environmental Regulation Type',
                ServiceFieldDefinitions.EnvironmentalRegulation,
                AttributeDefinitionTypeEnum.FILE
            ))
        })
    })

    return attributes
}

export const toCommentsAttributes = (
    comments: string
): AttributeModel[] => {
    const attributes : AttributeModel[] = []

    if (comments) {
        attributes.push(createAttribute(
            {type: AttributeValueType.SIMPLE, value: comments, composedByAttributes: [] },
            'Comments',
            ServiceFieldDefinitions.Comments,
            AttributeDefinitionTypeEnum.STRING
        ))
    }
    return attributes
}

